"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxonomyDetailsLayout = exports.TaxonomyDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var taxonomy_entity_expertise_1 = require("./taxonomy-entity-expertise");
var main_aside_1 = require("../elements/main-aside");
var grid_1 = require("../elements/grid");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var entity_list_section_1 = require("./entity-list-section");
var taxonomy_entity_incoming_lists_1 = require("./taxonomy-entity-incoming-lists");
var entity_link_value_1 = require("./entity-link-value");
var height_clip_1 = require("../elements/height-clip");
var lodash_1 = require("lodash");
exports.TaxonomyDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ExpertiseStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(4))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AboutSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IncomingListsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding: 0 0 ", " 0;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "], ["\n    padding: 0 0 ", " 0;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n\n    a {\n      font-size: 1em;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark'))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ClipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var VideoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  AboutSection: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), AboutSectionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Expertise: (0, styled_components_1.default)(taxonomy_entity_expertise_1.TaxonomyEntityExpertise)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ExpertiseStyles),
  IncomingLists: (0, styled_components_1.default)(taxonomy_entity_incoming_lists_1.TaxonomyEntityIncomingLists)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), IncomingListsStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  Clip: (0, styled_components_1.default)(height_clip_1.HeightClip)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ClipStyles)
};
var TaxonomyDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    mainPreIncoming = props.mainPreIncoming,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter;
  var description = entity.description,
    intro = entity.intro,
    _a = entity.moderators,
    moderators = _a === void 0 ? [] : _a;
  var hasDescription = description && description.text;
  var hasModerators = !!moderators.length;
  var video = (0, lodash_1.get)(entity, 'video');
  var hasVideo = !!video;
  var hasAside = asideHeader || asideFooter;
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, hasDescription && react_1.default.createElement(My.Clip, {
      maxHeight: 250
    }, react_1.default.createElement(My.AboutSection, {
      title: "About:"
    }, react_1.default.createElement(My.Intro, {
      entity: intro
    }), react_1.default.createElement(My.Description, {
      entity: description
    }))), hasModerators && react_1.default.createElement(My.Section, {
      title: "Moderators:"
    }, react_1.default.createElement(My.Grid, {
      columns: 3,
      spacing: 0,
      items: moderators.map(function (m) {
        return react_1.default.createElement(My.LinkValue, {
          entity: m
        });
      })
    })), react_1.default.createElement(My.Expertise, {
      entity: entity
    }), hasVideo && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.LinkValue, {
      entity: video
    })), mainPreIncoming, react_1.default.createElement(My.IncomingLists, {
      entity: entity
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      title: "",
      items: moderators
    }), asideFooter)
  }));
};
exports.TaxonomyDetailsLayout = TaxonomyDetailsLayout;
exports.TaxonomyDetailsLayout.defaultProps = exports.TaxonomyDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29;